export interface ISourcePrintable {
  printSource(source: string, copies: number, shouldSelectPrinter: boolean, shouldPrintWatermarkForcibly: boolean, launchRequestKey: string): void;
}

export function instanceOfISourcePrintable(instance: any): instance is ISourcePrintable {
  return instance && (instance.printSource !== undefined);
}
